import React from 'react';
import { ReactComponent as HeaderLogo } from '../assets/headerLogo.svg';
import left from './1.png'; 
import center from './2.png'; 
import rigth from './3.png'; 

import '../App.scss';
import styles from './styles.module.scss'

const DeleteAccount = () => {
  return (
    <div className="container">
      <main className='main-frame'>
        <header className="header">
          <div className="header-left">
            <HeaderLogo/>
            <div className="logo">FoodZee</div>
          </div>

          <div className="header-right">
            <button className="contactButton">support@macryx.app</button>
          </div>
        </header>
        <div className={styles.mainTitle}>Account Deletion</div>
        <main className="mainContent" style={{ alignItems: 'flex-start', marginBottom: 10}}>
          <div className={styles.card}>
            <div className={styles.cardTitle}><span>Step 1</span>Go to settings</div>
            <img src={left} className={styles.image} />
          </div>
          <div className={styles.card}>
           <div className={styles.cardTitle}><span>Step 2</span>Select Delete account</div>
           <img src={center} className={styles.image} />
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}><span>Step 3</span>Click Delete account</div>
            <img src={rigth} className={styles.image} />
          </div>
        </main>

        <footer className="footer">
          <div className="footer-left">
            <span className="footer-left-first">EL Care LLC</span>
            <span className="footer-left-second">7910 4th Street North, 300, St. Petersburg, FL, United States</span>
          </div>

          <div className="footer-right">
            <span className="footer-right-first">support@macryx.app</span>
          </div>
        </footer>
      </main>
    </div>
  );
};

export default DeleteAccount;